
import {
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,
  UPDATE_ADMIN_REQUEST,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAILURE,
  CREATE_ADMIN_REQUEST,
  CREATE_ADMIN_SUCCESS,
  CREATE_ADMIN_FAILURE,
  FETCH_PROGRAMMES_REQUEST,
  FETCH_PROGRAMMES_SUCCESS,
  FETCH_PROGRAMMES_FAILURE,
} from "../actions/AdminActions";

const initialState = {
  loading: false,
  admins: [],
  programmes: [], // ✅ Always defined
  error: null,
  updateSuccess: false,
  createSuccess: false,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMINS_REQUEST:
    case UPDATE_ADMIN_REQUEST:
    case CREATE_ADMIN_REQUEST:
    case FETCH_PROGRAMMES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        updateSuccess: false,
        createSuccess: false,
      };

    case FETCH_ADMINS_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: action.payload.data,
      };

    case FETCH_ADMINS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: true,
      };

    case UPDATE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: true,
      };

    case CREATE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ✅ New cases for programmes
    case FETCH_PROGRAMMES_SUCCESS:
      return {
        ...state,
        loading: false,
        programmes: action.payload.data, 
      };

    case FETCH_PROGRAMMES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default adminReducer;
